import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'

import { formatDate } from '@atheneum/api/dist/lib'

import EmployeeInitials from '@components/EmployeeInitials'
import InfoIcon from '@components/Icon/Info'
import { StatusLabel } from '@components/StatusLabel'
import Tooltip from '@components/Tooltip/Tooltip'

class ProjectSearchItem extends Component {
  static propTypes = {
    project: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    isSelected: PropTypes.bool
  }

  render () {
    return (
      <div
        className={`search-item ${this.props.isSelected ? 'active' : ''}`}
        onClick={this.props.onClick}
      >
        <div className='pull-right project-search-item__employee-initials-wrapper'>
          {this.props.project.employeeData.map(employee => (
            <EmployeeInitials key={employee.id} employee={employee} />
          ))}
        </div>
        <div>
          <span className='name'>{this.props.project.name}</span>
          {this.props.project.highlight ? (
            <Tooltip
              tooltip={
                <div
                  className='project-search-item__tooltip'
                  dangerouslySetInnerHTML={{
                    __html: this.props.project.highlight.background
                  }}
                />
              }
            >
              <div className='iconWrapper'>
                <InfoIcon />
              </div>
            </Tooltip>
          ) : (
            ''
          )}
        </div>
        <div>{this.props.project.account}</div>
        <div>
          <div>
            <span className='search-item-date'>
              {formatDate(this.props.project.startDate)}
            </span>
            &nbsp;
            <StatusLabel
              statusId={this.props.project.statusId}
              statusesType='projectStatuses'
            />
          </div>
        </div>
      </div>
    )
  }
}

export default observer(ProjectSearchItem)
